import { IconWithText } from 'common/icon/icon-with-text.js';
import { TableDataHeaders } from 'types/data-tables/column-by-key.js';
import { RenderHeaderProps } from 'utilities/buildTables/headers/renderHeader.js';

export function RenderHeader({
  headers,
  cellInfo,
  getCellClassNames,
  alignCenter = true,
}: RenderHeaderProps<TableDataHeaders> & { alignCenter?: boolean }) {
  const genericClassNames = getCellClassNames(cellInfo);
  const wrapperClasses = alignCenter ? 'u-flex u-flexJustifyCenter' : '';
  const { icon, title: text } = headers;
  if (icon) {
    return (
      <th className={`small u-textRegular u-textTruncate no-width sticky-col u-pR-0 ${genericClassNames}`}>
        <div className={wrapperClasses}>
          <IconWithText
            icon={icon}
            iconClass="u-textSlate svg--fill-inherit"
            classes=" IconWithText--vCenter IconWithText--small "
          >
            {text}
          </IconWithText>
        </div>
      </th>
    );
  }

  return (
    <th className={`small u-textBold u-textTruncate no-width sticky-col u-pR-0  ${genericClassNames}`}>
      <div data-module="render-header-table-forecast " className="u-pL-0">
        <span>{text}</span>
      </div>
    </th>
  );
}
